import { render, staticRenderFns } from "./upload-bill.vue?vue&type=template&id=4dee61ad&"
import script from "./upload-bill.vue?vue&type=script&lang=js&"
export * from "./upload-bill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "upload-bill.vue"
export default component.exports